import { render, staticRenderFns } from "./TaskAssets.vue?vue&type=template&id=94a533a8&scoped=true"
import script from "./TaskAssets.vue?vue&type=script&lang=js"
export * from "./TaskAssets.vue?vue&type=script&lang=js"
import style0 from "./TaskAssets.scss?vue&type=style&index=0&id=94a533a8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a533a8",
  null
  
)

export default component.exports